import { NavLink } from "react-router-dom";

export function CustomerTabs({ clientId, active }) {
  const tabs = [
    { key: "checklist", label: "Payroll Checklist", to: `/clients/${clientId}/checklist` },
    { key: "dashboard", label: "Dashboard", to: `/clients/${clientId}/dashboard` },
    { key: "py", label: "PY Results", to: `/clients/${clientId}/py-results` },
    { key: "charts", label: "Variance Charts", to: `/clients/${clientId}/compare` },
  ];
  return (
    <div className="mt-5 flex gap-1 border-b border-border" data-testid="customer-tabs">
      {tabs.map((t) => (
        <NavLink
          key={t.key}
          to={t.to}
          data-testid={`tab-${t.key}`}
          className={`relative -mb-px px-4 py-2.5 text-sm font-semibold transition-colors ${
            t.key === active
              ? "border-b-2 border-foreground text-foreground"
              : "border-b-2 border-transparent text-muted-foreground hover:text-foreground"
          }`}
        >
          {t.label}
        </NavLink>
      ))}
    </div>
  );
}
